// extracted by mini-css-extract-plugin
export default {"profile_name":"ProfileName_profile_name__D+sQX","focus":"ProfileName_focus__mNIt7"};